import React, { FC } from 'react';
import {
  Container,
  Content,
  WarningIcon,
  Text,
  WrapperButton,
  Button,
} from './styles';
import { Props } from './types';

const Modal: FC<Props> = ({
  isPublishing,
  open,
  onCancel,
  onDiscard,
  onPublish,
}) => {
  return (
    <Container open={open} handleClose={onCancel}>
      <Content>
        <WarningIcon />
        <Text>You are leaving without publishing the changes</Text>
        <WrapperButton>
          <Button
            type="button"
            variant="outlined"
            color="secondary"
            onClick={onDiscard}
            disabled={isPublishing}
          >
            Discard
          </Button>
          <Button
            type="submit"
            color="primary"
            onClick={onPublish}
            disabled={isPublishing}
          >
            Publish
          </Button>
        </WrapperButton>
      </Content>
    </Container>
  );
};

export default Modal;

// TODO: TFR-29 add story to component
